/* Los Magos Shopify Theme — theme.js */

(function() {
  'use strict';

  /* ── Mobile navigation ──────────────────────────────────────────────────── */
  var toggleBtn = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var closeBtn  = document.querySelector('.mobile-nav-close');

  if (toggleBtn && mobileNav) {
    toggleBtn.addEventListener('click', function() {
      var open = mobileNav.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }
  if (closeBtn && mobileNav) {
    closeBtn.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  /* ── Product gallery thumbnails ─────────────────────────────────────────── */
  var thumbs   = document.querySelectorAll('.product-thumb');
  var mainImg  = document.getElementById('product-main-img');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) mainImg.src = this.dataset.image;
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Quantity selector ──────────────────────────────────────────────────── */
  var qtyInput = document.querySelector('.qty-input');
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');

  if (qtyInput) {
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = val + 1;
      });
    }
  }

  /* ── Product variant selection ──────────────────────────────────────────── */
  var optionBtns = document.querySelectorAll('.product-option-btn');
  var variantInput = document.querySelector('input[name="id"]');
  var priceDisplay = document.getElementById('product-price');

  if (optionBtns.length && typeof window.productVariants !== 'undefined') {
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var index = parseInt(this.dataset.optionIndex, 10);
        var value = this.dataset.value;

        document.querySelectorAll('[data-option-index="' + index + '"]').forEach(function(b) {
          b.classList.remove('active');
        });
        this.classList.add('active');

        var selected = [];
        document.querySelectorAll('.product-option').forEach(function(optEl) {
          var activeBtn = optEl.querySelector('.product-option-btn.active');
          if (activeBtn) selected.push(activeBtn.dataset.value);
        });

        var match = window.productVariants.find(function(v) {
          return v.options.every(function(o, i) { return o === selected[i]; });
        });

        if (match && variantInput) {
          variantInput.value = match.id;
          if (priceDisplay) {
            priceDisplay.textContent = formatMoney(match.price);
          }
        }
      });
    });
  }

  // No decimals, to match Settings > Store details > Currency formatting
  // ({{amount_no_decimals}}). All prices are whole dollars.
  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString();
  }

  /* ── Sticky header shadow on scroll ────────────────────────────────────── */
  var header = document.getElementById('site-header');
  if (header) {
    var scrolled = false;
    window.addEventListener('scroll', function() {
      var isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        header.style.boxShadow = scrolled ? '0 2px 16px rgba(38,56,49,0.10)' : 'none';
      }
    }, { passive: true });
  }

})();